
import { defineComponent, onBeforeMount, ref, computed } from "vue";
import { apiService } from "@services/api.service";
import { ciTrackingService } from "@services/ci-tracking.service";
import { CurrentUser } from "@utils/user";
import { MetaInfo } from "vue-meta";
import { alternateService } from "@services/alternate.service";
import { Loader, useLoader } from "@composables/loader";

export default defineComponent({
  metaInfo(): MetaInfo {
    const title = this.$t("ui.views.privacy_policy.meta_tags.title") as string;
    const description = this.$t("ui.views.privacy_policy.meta_tags.description") as string;
    return {
      title: title,
      link: alternateService.fromRoute(this.$route),
      meta: [
        { vmid: "description", name: "description", content: description },
        { vmid: "og:title", property: "og:title", content: title },
        { vmid: "og:description", property: "og:description", content: description },
        { vmid: "twitter:title", name: "twitter:title", content: title },
        { vmid: "twitter:description", name: "twitter:description", content: description },
      ],
    };
  },
  name: "CiPrivacyPolicyPage",
  setup() {
    const content = ref("");
    const contentRef = ref<HTMLDivElement | null>(null);
    const loading = computed(() => Loader.loading.state);
    const loader = useLoader();
    const isLoggedIn = computed(() => CurrentUser.signedIn);

    const trackPageView = async () => {
      await ciTrackingService.trackView("PrivacyPolicy", "unused");
    };

    const hideDOMElements = () => {
      if (!isLoggedIn.value || !contentRef.value) return;

      const elementsToHide = contentRef.value.querySelectorAll(".guests-only");
      elementsToHide.forEach((element) => {
        if (element) (element as HTMLElement).style.display = "none";
      });
    };

    onBeforeMount(async () => {
      loader.start();

      try {
        const { data } = await apiService.pages.getPrivacyPolicy();
        content.value = data.html;
        await trackPageView();

        setTimeout(hideDOMElements, 0);
      } catch (error) {
        apiService.handleAPIError(error);
      } finally {
        loader.stop();
      }
    });

    return {
      content,
      contentRef,
      isLoggedIn,
      loading,
    };
  },
});
